module.exports = __webpack_public_path__ + "img/play.ca3bd82d.png";